import isEmpty from 'lodash/isEmpty';

export function adobeFields(error) {
  const fields = {};
  if (error.primaryServicing && isEmpty(error.primaryServicing.streetLine1)) {
    fields['primaryServicing.streetLine1'] = '';
  }
  if (error.primaryServicing && isEmpty(error.primaryServicing.city)) {
    fields['primaryServicing.city'] = '';
  }
  if (error.primaryServicing && isEmpty(error.primaryServicing.state)) {
    fields['primaryServicing.state'] = '';
  }
  if (error.primaryServicing && isEmpty(error.primaryServicing.zipCode)) {
    fields['primaryServicing.zipCode'] = '';
  }
  if (
    error.primaryServicing &&
    isEmpty(error.primaryServicing.primaryServicingProof)
  ) {
    fields['primaryServicing.primaryServicingProof'] = '';
  }
  if (error.primaryBilling && isEmpty(error.primaryBilling.streetLine1)) {
    fields['primaryBilling.streetLine1'] = '';
  }
  if (error.primaryBilling && isEmpty(error.primaryBilling.city)) {
    fields['primaryBilling.city'] = '';
  }
  if (error.primaryBilling && isEmpty(error.primaryBilling.state)) {
    fields['primaryBilling.state'] = '';
  }
  if (error.primaryBilling && isEmpty(error.primaryBilling.zipCode)) {
    fields['primaryBilling.zipCode'] = '';
  }
  if (
    error.primaryBilling &&
    isEmpty(error.primaryBilling.primaryBillingProof)
  ) {
    fields['primaryBilling.primaryBillingProof'] = '';
  }
  if (error.primaryRemittance && isEmpty(error.primaryRemittance.streetLine1)) {
    fields['primaryRemittance.streetLine1'] = '';
  }
  if (error.primaryRemittance && isEmpty(error.primaryRemittance.city)) {
    fields['primaryRemittance.city'] = '';
  }
  if (error.primaryRemittance && isEmpty(error.primaryRemittance.state)) {
    fields['primaryRemittance.state'] = '';
  }
  if (error.primaryRemittance && isEmpty(error.primaryRemittance.zipCode)) {
    fields['primaryRemittance.zipCode'] = '';
  }
  if (
    error.primaryRemittance &&
    isEmpty(error.primaryRemittance.primaryRemittanceProof)
  ) {
    fields['primaryRemittance.primaryRemittanceProof'] = '';
  }

  if (error.secondaryServicing && !isEmpty(error.secondaryServicing[0])) {
    if (isEmpty(error.secondaryServicing[0].streetLine1)) {
      fields['secondaryServicing1.streetLine1'] = '';
    }
    if (isEmpty(error.secondaryServicing[0].city)) {
      fields['secondaryServicing1.city'] = '';
    }
    if (isEmpty(error.secondaryServicing[0].state)) {
      fields['secondaryServicing1.state'] = '';
    }
    if (isEmpty(error.secondaryServicing[0].zipCode)) {
      fields['secondaryServicing1.zipCode'] = '';
    }
    if (isEmpty(error.secondaryServicing[0].proof)) {
      fields['secondaryServicing1.secondaryServicingProof'] = '';
    }
  }
  if (error.secondaryServicing && !isEmpty(error.secondaryServicing[1])) {
    if (isEmpty(error.secondaryServicing[1].streetLine1)) {
      fields['secondaryServicing2.streetLine1'] = '';
    }
    if (isEmpty(error.secondaryServicing[1].city)) {
      fields['secondaryServicing2.city'] = '';
    }
    if (isEmpty(error.secondaryServicing[1].state)) {
      fields['secondaryServicing2.state'] = '';
    }
    if (isEmpty(error.secondaryServicing[1].zipCode)) {
      fields['secondaryServicing2.zipCode'] = '';
    }
    if (isEmpty(error.secondaryServicing[1].proof)) {
      fields['secondaryServicing2.secondaryServicingProof'] = '';
    }
  }
  if (error.secondaryServicing && !isEmpty(error.secondaryServicing[2])) {
    if (isEmpty(error.secondaryServicing[2].streetLine1)) {
      fields['secondaryServicing3.streetLine1'] = '';
    }
    if (isEmpty(error.secondaryServicing[2].city)) {
      fields['secondaryServicing3.city'] = '';
    }
    if (isEmpty(error.secondaryServicing[2].state)) {
      fields['secondaryServicing3.state'] = '';
    }
    if (isEmpty(error.secondaryServicing[2].zipCode)) {
      fields['secondaryServicing3.zipCode'] = '';
    }
    if (isEmpty(error.secondaryServicing[2].proof)) {
      fields['secondaryServicing3.secondaryServicingProof'] = '';
    }
  }
  if (error.secondaryServicing && !isEmpty(error.secondaryServicing[3])) {
    if (isEmpty(error.secondaryServicing[3].streetLine1)) {
      fields['secondaryServicing4.streetLine1'] = '';
    }
    if (isEmpty(error.secondaryServicing[3].city)) {
      fields['secondaryServicing4.city'] = '';
    }
    if (isEmpty(error.secondaryServicing[3].state)) {
      fields['secondaryServicing4.state'] = '';
    }
    if (isEmpty(error.secondaryServicing[3].zipCode)) {
      fields['secondaryServicing4.zipCode'] = '';
    }
    if (isEmpty(error.secondaryServicing[3].proof)) {
      fields['secondaryServicing4.secondaryServicingProof'] = '';
    }
  }
  if (error.secondaryServicing && !isEmpty(error.secondaryServicing[4])) {
    if (isEmpty(error.secondaryServicing[4].streetLine1)) {
      fields['secondaryServicing5.streetLine1'] = '';
    }
    if (isEmpty(error.secondaryServicing[4].city)) {
      fields['secondaryServicing5.city'] = '';
    }
    if (isEmpty(error.secondaryServicing[4].state)) {
      fields['secondaryServicing5.state'] = '';
    }
    if (isEmpty(error.secondaryServicing[4].zipCode)) {
      fields['secondaryServicing5.zipCode'] = '';
    }
    if (isEmpty(error.secondaryServicing[4].proof)) {
      fields['secondaryServicing5.secondaryServicingProof'] = '';
    }
  }
  return fields;
}
